const cardItems = [
  {
    title: '韩漫精选：系统流必看 Top10',
    tag: '编辑精选',
    desc: '从《我独自升级》到《SSS级猎人》，系统流韩漫的天花板都在这里了。每一部都是口碑与人气双爆的佳作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20compilation%20illustration%20with%20multiple%20fantasy%20character%20silhouettes%2C%20warm%20gradient%20background%20in%20coral%20and%20gold%2C%20modern%20minimal%20design%2C%20editorial%20layout%20style%2C%20clean%20composition&width=640&height=420&seq=card-cover-01&orientation=landscape',
  },
  {
    title: '国漫崛起：这些作品不输日漫',
    tag: '深度盘点',
    desc: '《剑道第一仙》《全职高手》《一念永恒》——国漫正在用实力证明自己，每一帧都是壁纸级别的画质。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%20compilation%20with%20martial%20arts%20characters%2C%20ink%20wash%20painting%20style%20blended%20with%20modern%20anime%2C%20warm%20earthy%20tones%2C%20elegant%20composition%2C%20editorial%20design&width=640&height=420&seq=card-cover-02&orientation=landscape',
  },
  {
    title: '日漫殿堂：永不过时的经典',
    tag: '怀旧推荐',
    desc: '《鬼灭之刃》《咒术回战》《海贼王》——这些日漫神作承载了无数人的青春记忆，每一部都值得反复回味。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20classic%20collection%20illustration%20with%20iconic%20shonen%20characters%2C%20vintage%20paper%20texture%2C%20warm%20sepia%20and%20red%20tones%2C%20nostalgic%20atmosphere%2C%20artistic%20composition&width=640&height=420&seq=card-cover-03&orientation=landscape',
  },
  {
    title: '穿越题材：换个身份活一次',
    tag: '类型推荐',
    desc: '《某天成为公主》《公爵的契约未婚妻》——穿越到异世界成为主角，体验完全不同的精彩人生。',
    image: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20manhwa%20style%20illustration%20with%20elegant%20historical%20dress%20characters%2C%20royal%20palace%20setting%2C%20soft%20pink%20and%20cream%20lighting%2C%20romantic%20atmosphere%2C%20decorative%20composition&width=640&height=420&seq=card-cover-04&orientation=landscape',
  },
  {
    title: '完结精品：一口气看到结局',
    tag: '完结推荐',
    desc: '追更是快乐，完结是幸福。为你精选口碑完结漫画，不用担心断更，从头到尾完整畅读。',
    image: 'https://readdy.ai/api/search-image?query=Complete%20manga%20collection%20illustration%20with%20stacked%20books%20and%20comic%20pages%2C%20warm%20library%20atmosphere%2C%20golden%20lighting%2C%20cozy%20reading%20vibe%2C%20minimal%20clean%20design&width=640&height=420&seq=card-cover-05&orientation=landscape',
  },
  {
    title: '新番速递：本月必追连载',
    tag: '新番推荐',
    desc: '每月精选最新上架的连载漫画，从韩漫新秀到国漫黑马，第一手追更资讯不错过任何一部好作品。',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20new%20webtoon%20launch%20illustration%20with%20vibrant%20dynamic%20characters%2C%20modern%20colorful%20design%2C%20excitement%20and%20energy%2C%20clean%20gradient%20background%2C%20editorial%20style%2C%20fresh%20aesthetic&width=640&height=420&seq=card-cover-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">编辑精选</h2>
          <p className="text-foreground-500 text-sm mt-2">编辑团队精心挑选，每一部都值得一看</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <div key={i} className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group">
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-md bg-accent-100/70 text-accent-700 text-[10px] font-medium">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-1">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}